import { ELandStatusType, getTermsValue } from '@/packages/JsonQuery';

import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagLandStatusSchema } from '../types';

const TEXT_MAP: { [key in ELandStatusType]: string } = {
  [ELandStatusType.Farm]: 'Фермерское хозяйство',
  [ELandStatusType.PrivateFarm]: 'Личное подсобное хозяйство',
  [ELandStatusType.Gardening]: 'Садоводство',
  [ELandStatusType.IndustrialLand]: 'Земля промназначения',
  [ELandStatusType.InvestmentProject]: 'Инвестпроект',
  [ELandStatusType.IndividualHousingConstruction]: 'ИЖС',
  [ELandStatusType.CountryhouseNonCommercialPartnership]: 'ДНП',
};

export const landStatus: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermsValue('land_status')(jsonQuery) || [];

    const tagsGroup: TagLandStatusSchema[] = value.map(key => ({
      group: 'landStatus',
      text: TEXT_MAP[key],
      data: key,
    }));

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ jsonQuery, onChange }, tag: TagLandStatusSchema) {
    const currentValue = getTermsValue('land_status')(jsonQuery) || [];
    const nextValue = nonEmptyArrayOr(currentValue.filter(item => item !== tag.data));

    onChange({
      action: 'setLandStatusTypes',
      arguments: [nextValue],
    });
  },
};
